export default __webpack_public_path__ + "static/media/Alert_Icon.41016104.svg";